<template>
  <main id="profileInvoicePage" class="container mb-3">
    <div class="row">
      <CustomerProfileNavComponent id="sideNav"
                                   class="col-lg-4 col-sm-12 side-nav"
      ></CustomerProfileNavComponent>

      <div class="profile-page col-lg-8 col col-sm-12">
        <h3>{{ $t('profile_invoices') }}</h3>

          <div class="mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col">Nr.</th>
                <th scope="col">{{ $t('date') }}</th>
                <th scope="col">{{ $t('booking_id') }}</th>
                <th scope="col">{{ $t('service') }}</th>
                <th scope="col">{{ $t('total') }}</th>
                <th scope="col">{{ $t('payment_due') }}</th>
                <th scope="col">{{ $t('status') }}</th>
                <th scope="col">{{ $t('invoice') }}</th>
                <th scope="col">{{ $t('actions') }}</th>
              </tr>
              </thead>
              <tbody>
                <template v-for="invoice of invoices">
                  <tr :class="invoice.is_paid ? 'table-success' : ''">
                    <th scope="row">{{ invoice.id }}</th>
                    <td>{{ invoice.date }}</td>
                    <td>{{ invoice.booking_number }}</td>
                    <td>{{ invoice.service_type ? $t(invoice.service_type) : '-' }}</td>
                    <td>{{ invoice.tax_total }} {{ invoice.currency }}</td>
                    <td>{{ invoice.payment_due }}</td>
                    <td>
                      <template v-if="invoice.status === INVOICE_STATUSES.PAID">{{ $t('status_paid') }}</template>
                      <template v-if="invoice.status === INVOICE_STATUSES.WAITING_PAYMENT">{{ $t('status_waiting_payment') }}</template>
                      <template v-if="invoice.status === INVOICE_STATUSES.EXPIRED">{{ $t('status_expired') }}</template>
                    </td>
                    <td>
                      <template v-if="invoice.invoice_file_name">
                        <a href="#"
                             @click="handleDownload(invoice.invoice_url, invoice.invoice_file_name)"
                        >{{ $t('invoice') }}</a>
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td>
                      <template v-if="!invoice.is_paid && invoice.is_payable">
                        <ul style="padding-left: 0;">
                          <li>
                            <a href="#"
                               @click="handlePay(invoice)"
                            >{{ $t('pay') }}</a>
                          </li>
                        </ul>
                      </template>
                      <template v-else>-</template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </main>

</template>

<script lang="ts">
import './profileInvoicesPage.scss';

import {defineComponent} from "vue";

// @ts-ignore
import CustomerProfileNavComponent from "../../components/CustomerProfileNav/CustomerProfileNavComponent.vue";

import {routesConst} from "../../routes";
import axios from "axios";
import apiService from "../../services/apiService";
import type {IApiResponseBooking} from "@/interfaces/apiResponseInterfaces/IApiResponseBooking.interface";
import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";
import {useStore} from "vuex";
import NameOfHelper from "../../helpers/nameOfHelper";
import type {IApiResponseInvoice} from "../../interfaces/apiResponseInterfaces/IApiResponseInvoice.interface";
import {INVOICE_STATUSES} from "../../interfaces/apiResponseInterfaces/IApiResponseInvoice.interface";

export default defineComponent({
  name: "ProfileInvoicesPage",
  computed: {
    INVOICE_STATUSES() {
      return INVOICE_STATUSES
    }
  },
  components: {
    CustomerProfileNavComponent,
  },

  setup() {
    const store = useStore();

    return {
      store
    };
  },

  data() {
    return {
      ServiceTypes: ServiceTypes,
      invoices: <IApiResponseInvoice[]>[],
    }
  },

  methods: {
    getInvoices(): void {
      axios.get(apiService.customerGetInvoices())
          .then(response => {
            this.invoices = <IApiResponseInvoice[]>response.data.data;
          })
          .catch(err => {
            console.error(err);
          })
    },

    handleDownload(url: string, fileName: string): void {
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

    handlePay(invoice: IApiResponseInvoice): void {
      axios({
        url: apiService.customerGetBooking() + invoice.booking_id,
        method: 'GET',
      }).then(response => {
        this.handlePayBookingRedirect(<IApiResponseBooking>response.data.data);
      });
    },

    handlePayBookingRedirect(booking: IApiResponseBooking): void {
        // TODO
        alert('NOTE. THis only made for rent service without driver. With driver needs to be implemented also for transportation bookings.');
        console.log('booking', booking);
        // in case if store is not empty...
        this.store.commit('order/CLEAR_STATE');
        this.store.commit('orderFalseDriver/CLEAR_STATE');
        this.store.commit('orderTrueDriver/CLEAR_STATE');

        // this.store.commit('orderTrueDriverRoute/CLEAR_STATE'); // TODO copy from order clear state
        // this.store.commit('orderTrueDriverDates/CLEAR_STATE'); // TODO copy from order clear state

        this.store.commit('orderTrueRoundTrip/CLEAR_STATE');
        this.store.commit('orderFalseRoundTrip/CLEAR_STATE');
        this.store.commit('vehicle/CLEAR_STATE');

        let pickupDate = <string|null>null;
        let pickupTime = <string|null>null;

        if (booking.pickup) {
          const pickup = booking.pickup as string;
          const pickupParts = pickup.split(' ');
          const pickupTimeParts = pickupParts[1].split(':');

          pickupDate = pickupParts[0] + 'T' + pickupParts[1] + '.000Z';
          pickupTime = pickupTimeParts[0] + ':' + pickupTimeParts[1];
        }

        if (! pickupDate || ! pickupTime) {
          alert('Something went wrong. Please try again later. If the problem persists please contact us!');
          throw new Error('Order can\'t be without dates!');
        }

        let endDate = <string|null>null;
        let endTime = <string|null>null;

        if (booking.dropoff) {
          const end = booking.dropoff as string;
          const endParts = end.split(' ');
          const endTimeParts = endParts[1].split(':');

          endDate = endParts[0] + 'T' + endParts[1] + '.000Z';
          endTime = endTimeParts[0] + ':' + endTimeParts[1];
        }

        let state = this.store.state.orderFalseDriver;
        const nameOf = (c) => NameOfHelper.obj(c);

        // filling store with new data from chosen booking
        this.store.commit( 'orderFalseDriver/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.id), value: booking.id},
          {prop: nameOf(() => state.isRentFormValid), value: true},
          {prop: nameOf(() => state.passengerCount), value: booking.travellers},

          {prop: nameOf(() => state.pickupTime), value: pickupTime},
          {prop: nameOf(() => state.pickupDate), value: pickupDate},

          {prop: nameOf(() => state.endTime), value: endTime},
          {prop: nameOf(() => state.endDate), value: endDate},

            // @ts-ignore
          {prop: nameOf(() => state.destination), value: JSON.parse(booking.pickup_address_google_response as string)},
          {prop: nameOf(() => state.formatted_address), value: booking.pickup_addr},
        ]);

        state = this.store.state.vehicle;
        const vehicle = booking.vehicle;

        this.store.commit( 'vehicle/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.selectedId), value: vehicle.id},
          {prop: nameOf(() => state.selectedVehicle), value: vehicle},
        ]);

        state = this.store.state.order;

        this.store.commit( 'order/SET_STATE_PROP_VALUE', [
          {prop: nameOf(() => state.withDriver), value: false}, // TODO check if it's with or without
          {prop: nameOf(() => state.serviceType), value: ServiceTypes.SERVICE_RENT}, // TODO Determine the service type earlier
          {prop: nameOf(() => state.serviceType), value: ServiceTypes.SERVICE_RENT}, // TODO Determine the service type earlier
        ]);

        // INITIALIZE
        this.store.commit('order/INITIALIZE_ORDER_STATE');
        this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
        this.store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
        this.store.commit('orderTrueRoundTrip/INITIALIZE_TRUE_ROUND_TRIP_STATE');
        this.store.commit('orderFalseRoundTrip/INITIALIZE_FALSE_ROUND_TRIP_STATE');
        this.store.commit('vehicle/INITIALIZE');

        setTimeout(() => {
          this.$router.push(routesConst.ORDER);
        });
    }

    //
    // /**
    //  * NOTE: TODO Only order without driver covered
    //  * @param booking
    //  */
    // handlePayTheBooking(booking: IApiResponseBooking): void {
    //   // TODO
    //   alert('NOTE. THis only made for rent service without driver. With driver needs to be implemented also for transportation bookings.');
    //   console.log('booking', booking);
    //   // in case if store is not empty...
    //   this.store.commit('order/CLEAR_STATE');
    //   this.store.commit('orderFalseDriver/CLEAR_STATE');
    //   this.store.commit('orderTrueDriver/CLEAR_STATE');
    //
    //   // this.store.commit('orderTrueDriverRoute/CLEAR_STATE'); // TODO copy from order clear state
    //   // this.store.commit('orderTrueDriverDates/CLEAR_STATE'); // TODO copy from order clear state
    //
    //   this.store.commit('orderTrueRoundTrip/CLEAR_STATE');
    //   this.store.commit('orderFalseRoundTrip/CLEAR_STATE');
    //   this.store.commit('vehicle/CLEAR_STATE');
    //
    //   let pickupDate = <string|null>null;
    //   let pickupTime = <string|null>null;
    //
    //   if (booking.pickup) {
    //     const pickup = booking.pickup as string;
    //     const pickupParts = pickup.split(' ');
    //     const pickupTimeParts = pickupParts[1].split(':');
    //
    //     pickupDate = pickupParts[0] + 'T' + pickupParts[1] + '.000Z';
    //     pickupTime = pickupTimeParts[0] + ':' + pickupTimeParts[1];
    //   }
    //
    //   if (! pickupDate || ! pickupTime) {
    //     alert('Something went wrong. Please try again later. If the problem persists please contact us!');
    //     throw new Error('Order can\'t be without dates!');
    //   }
    //
    //   let endDate = <string|null>null;
    //   let endTime = <string|null>null;
    //
    //   if (booking.dropoff) {
    //     const end = booking.dropoff as string;
    //     const endParts = end.split(' ');
    //     const endTimeParts = endParts[1].split(':');
    //
    //     endDate = endParts[0] + 'T' + endParts[1] + '.000Z';
    //     endTime = endTimeParts[0] + ':' + endTimeParts[1];
    //   }
    //
    //   let state = this.store.state.orderFalseDriver;
    //   const nameOf = (c) => NameOfHelper.obj(c);
    //
    //   // filling store with new data from chosen booking
    //   this.store.commit( 'orderFalseDriver/SET_STATE_PROP_VALUE', [
    //     {prop: nameOf(() => state.id), value: booking.id},
    //     {prop: nameOf(() => state.isRentFormValid), value: true},
    //     {prop: nameOf(() => state.passengerCount), value: booking.travellers},
    //
    //     {prop: nameOf(() => state.pickupTime), value: pickupTime},
    //     {prop: nameOf(() => state.pickupDate), value: pickupDate},
    //
    //     {prop: nameOf(() => state.endTime), value: endTime},
    //     {prop: nameOf(() => state.endDate), value: endDate},
    //
    //       // @ts-ignore
    //     {prop: nameOf(() => state.destination), value: JSON.parse(booking.pickup_address_google_response as string)},
    //     {prop: nameOf(() => state.formatted_address), value: booking.pickup_addr},
    //   ]);
    //
    //   state = this.store.state.vehicle;
    //   const vehicle = booking.vehicle;
    //
    //   this.store.commit( 'vehicle/SET_STATE_PROP_VALUE', [
    //     {prop: nameOf(() => state.selectedId), value: vehicle.id},
    //     {prop: nameOf(() => state.selectedVehicle), value: vehicle},
    //   ]);
    //
    //   state = this.store.state.order;
    //
    //   this.store.commit( 'order/SET_STATE_PROP_VALUE', [
    //     {prop: nameOf(() => state.withDriver), value: false}, // TODO check if it's with or without
    //     {prop: nameOf(() => state.serviceType), value: ServiceTypes.SERVICE_RENT}, // TODO Determine the service type earlier
    //   ]);
    //
    //   // INITIALIZE
    //   this.store.commit('order/INITIALIZE_ORDER_STATE');
    //   this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
    //   this.store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
    //   this.store.commit('orderTrueRoundTrip/INITIALIZE_TRUE_ROUND_TRIP_STATE');
    //   this.store.commit('orderFalseRoundTrip/INITIALIZE_FALSE_ROUND_TRIP_STATE');
    //   this.store.commit('vehicle/INITIALIZE');
    //
    //   setTimeout(() => {
    //     this.$router.push(routesConst.ORDER);
    //   });
    // },
    //
    // /**
    //  * Example: '2022-01-01 01:00:00' -> '2022-01-01 01:00
    //  * @param {string} str
    //  */
    // ensureDateTimeFormat(str: string): string {
    //   const pickupParts = str.split(' ');
    //   const pickupTimeParts = pickupParts[1].split(':');
    //
    //   return pickupParts[0] + ' ' + pickupTimeParts[0] + ':' + pickupTimeParts[1];
    // },
    // /**
    //  * @param {IApiResponseBooking} booking
    //  */
    // isBookingPickupDateLaterThanToday(booking: IApiResponseBooking): boolean {
    //   return new Date(booking.pickup as string).getTime() > new Date().getTime();
    // },
  },

  mounted() {
    this.getInvoices();
  },
})
</script>

<style scoped>

</style>